<template>
  <div :style="styleObject">
    <button
      type="button"
      class="d-none btn-show-modal-prices-updated"
      data-bs-toggle="modal"
      data-bs-target="#modalPricesUpdated"
    ></button>
    <div
      class="modal fade"
      :class="{ 'mpu-moo': !isKiosk }"
      id="modalPricesUpdated"
      tabindex="-1"
      aria-labelledby="modalPricesUpdatedLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <!-- Kiosk: same shell as the other kiosk popups. -->
      <KskModalShell v-if="isKiosk" :width="680" :show-close="false">
        <div class="mpu mpu--kiosk">
          <div class="mpu__icon"><span class="material-icons-round">price_change</span></div>
          <h2 id="modalPricesUpdatedLabel" class="mpu__title">{{ $t(i18nKey + "pricesUpdatedTitle") }}</h2>
          <p class="mpu__intro">{{ $t(i18nKey + "pricesUpdated") }}</p>
          <ul class="mpu__list">
            <li v-for="(line, index) in items" :key="index" class="mpu__row">
              <span class="mpu__name"><span class="mpu__qty">{{ line.quantity }}×</span> {{ line.name }}</span>
              <span class="mpu__prices">
                <span class="mpu__old">${{ line.from.toFixed(2) }}</span>
                <span class="mpu__arrow">→</span>
                <span class="mpu__new">${{ line.to.toFixed(2) }}</span>
              </span>
            </li>
          </ul>
        </div>
        <template #footer>
          <button type="button" class="mpu__ok mpu__ok--kiosk" data-bs-dismiss="modal">{{ $t("kiosk.common.ok") }}</button>
        </template>
      </KskModalShell>

      <div v-else class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body mpu">
            <div class="mpu__icon"><span class="material-icons-round">price_change</span></div>
            <h5 id="modalPricesUpdatedLabel" class="mpu__title">{{ $t(i18nKey + "pricesUpdatedTitle") }}</h5>
            <p class="mpu__intro">{{ $t(i18nKey + "pricesUpdated") }}</p>
            <ul class="mpu__list">
              <li v-for="(line, index) in items" :key="index" class="mpu__row">
                <span class="mpu__name"><span class="mpu__qty">{{ line.quantity }}×</span> {{ line.name }}</span>
                <span class="mpu__prices">
                  <span class="mpu__old">${{ line.from.toFixed(2) }}</span>
                  <span class="mpu__arrow">→</span>
                  <span class="mpu__new">${{ line.to.toFixed(2) }}</span>
                </span>
              </li>
            </ul>
          </div>
          <div class="modal-footer">
            <button type="button" class="mpu__ok" data-bs-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import KskModalShell from "@/views/kiosk/components/ui/KskModalShell.vue";

// Price Schedules: lists the cart lines whose price was updated (applyCartPrices) -
// item, old unit price struck through, new unit price - so a long cart stays readable.
export default {
  name: "ModalPricesUpdated",
  components: { KskModalShell },
  props: {
    // [{ name, quantity, from, to }] - unit prices as shown in the cart.
    items: {
      type: Array,
      default: () => [],
    },
    isKiosk: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // The icon, the new price and the OK button take the page's theme colour - the one
    // MyCart's own buttons (Pay Now, Pick up) use - not the separate theme 2 button colour.
    styleObject() {
      const theme = this.$store.state.mainThemeColorTheme2 || this.$store.state.color;
      return {
        "--color": theme,
        "--mlx-accent": theme,
        "--mlx-btn": theme,
      };
    },
    i18nKey() {
      return this.isKiosk ? "kiosk.checkout." : "cart.";
    },
  },
  methods: {
    open() {
      document.querySelector(".btn-show-modal-prices-updated").click();
    },
  },
};
</script>

<style scoped>
.mpu {
  text-align: center;
}
.mpu__icon .material-icons-round {
  font-size: 40px;
  color: var(--mlx-btn, var(--color, #f26b2c));
}
.mpu__title {
  margin: 6px 0 4px;
  font-weight: 700;
  color: #201a1a;
}
.mpu__intro {
  margin: 0 0 14px;
  font-size: 0.92rem;
  color: #5b5555;
  line-height: 1.45;
}
.mpu__list {
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 40vh;
  overflow-y: auto;
  text-align: left;
  border-top: 1px solid #f0e6e3;
}
.mpu__row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
  padding: 10px 2px;
  border-bottom: 1px solid #f0e6e3;
}
.mpu__name {
  min-width: 0;
  font-weight: 600;
  color: #201a1a;
  word-break: break-word;
}
.mpu__qty {
  color: #8a7f7d;
  font-weight: 600;
}
.mpu__prices {
  flex-shrink: 0;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}
.mpu__old {
  color: #9a908e;
  text-decoration: line-through;
  font-size: 0.9em;
}
.mpu__arrow {
  margin: 0 6px;
  color: #9a908e;
}
.mpu__new {
  font-weight: 700;
  color: var(--mlx-btn, var(--color, #f26b2c));
}
.mpu__ok {
  width: 100%;
  border: none;
  border-radius: 9999px;
  background-color: var(--mlx-btn, var(--color, #f26b2c));
  color: #fff;
  font-weight: 700;
  font-size: 0.95rem;
  padding: 0.8rem 1rem;
}
.mpu__ok--kiosk {
  font-size: 22px;
  padding: 18px 24px;
}
/* MOO: same card as the theme2 notification (ModalNotification.mlx-notify). */
.mpu-moo {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.mpu-moo .modal-dialog {
  max-width: 24rem;
  margin-left: auto;
  margin-right: auto;
  padding: 0 1rem;
}
.mpu-moo .modal-content {
  border: none;
  border-radius: 1.25rem;
  box-shadow: 0 20px 40px rgba(25, 28, 30, 0.18);
  overflow: hidden;
}
.mpu-moo .modal-body {
  padding: 1.5rem 1.25rem 0.75rem;
}
.mpu-moo .modal-footer {
  border-top: none;
  padding: 0.5rem 1.25rem 1.5rem;
}
/* Kiosk: larger type for the big screen. */
.mpu--kiosk .mpu__icon .material-icons-round {
  font-size: 56px;
}
.mpu--kiosk .mpu__title {
  font-size: 30px;
}
.mpu--kiosk .mpu__intro {
  font-size: 20px;
}
.mpu--kiosk .mpu__row {
  font-size: 22px;
  padding: 14px 4px;
}
</style>
